import React, { useEffect } from "react";
import { getDefaultCovers } from "../../../../api/asyncThuncks/settings";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux-hooks";
import { selectMainState } from "../../../../store/slices/main";
import DesctopPlayer from "./desctopPlayer/DesctopPlayer";
import FullScreenAudioPlayer from "./fullScreenAudioPlayer/FullScreenAudioPlayer";
import placeholder from "../../../../assets/playlist-placeholder.svg";

const HlsPlayer = () => {
  const dispatch = useAppDispatch();

  const {
    audioPlayer: { overTop, viewPlayer },
    idPlayingTrack: { cover, name, artist, isLiked },
    defaultCover,
  } = useAppSelector(selectMainState);
  const screenWidth = window.screen.width < 799;

  useEffect(() => {
    dispatch(getDefaultCovers());
  }, [dispatch]);

  return (
    <div className="w-full">
      {viewPlayer && overTop && screenWidth ? (
        <FullScreenAudioPlayer
          cover={cover?.icon || defaultCover || placeholder}
          defaultCover={defaultCover || placeholder}
          trackName={name}
          artist={artist}
          isLiked={isLiked}
        />
      ) : (
        <DesctopPlayer
          cover={cover?.icon || defaultCover || placeholder}
          defaultCover={defaultCover || placeholder}
          trackName={name}
          artist={artist}
          isLiked={isLiked}
        />
      )}
    </div>
  );
};

export default HlsPlayer;
